import React, { useEffect, useState } from 'react';
import {
  collection,
  query,
  where,
  getDocs,
  getDoc,
  doc
} from 'firebase/firestore';
import { db } from './firebase';
import TutorLayout from './TutorLayout';
import './ReviewWorkPage.css';

function ReviewWorkPage() {
  const [students, setStudents] = useState([]);
  const [search, setSearch] = useState('');
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [submissions, setSubmissions] = useState([]);
  const [showSubmissions, setShowSubmissions] = useState(false);
  const [sortField, setSortField] = useState(null);
const [sortOrder, setSortOrder] = useState('asc');

  function getMillionaireColorClass(amountStr) {
    if (!amountStr) return '';
  
    const num = parseInt(amountStr.replace(/[^\d]/g, '')) || 0;
  
    if (num === 1000000) return 'score-gold';
    if (num >= 32000) return 'score-green';
    if (num >= 1000) return 'score-orange';
    return 'score-red';
  }
  // Fetch all students from 'users' where role is 'student'
  useEffect(() => {
    const fetchStudents = async () => {
      const q = query(collection(db, 'users'), where('role', '==', 'student'));
      const snapshot = await getDocs(q);
      const list = snapshot.docs.map((doc) => ({
        uid: doc.id,
        ...doc.data(),
      }));
      setStudents(list);
    };
    fetchStudents();
  }, []);

  // Filtered students based on search input
  const filteredStudents = students.filter((student) => {
    const fullName = `${student.displayName || ''} ${student.surname || ''}`.toLowerCase();
    return fullName.includes(search.toLowerCase());
  });

  const handleReview = async () => {
    if (!selectedStudent) return;
  
    try {
      const q = query(
        collection(db, 'studentAssignmentSubmissions'),
        where('studentUID', '==', selectedStudent.uid)
      );
  
      const snapshot = await getDocs(q);
  
      const subs = await Promise.all(
        snapshot.docs.map(async (docSnap) => {
          const data = docSnap.data();
  
          // Fetch assignment title
          const assignmentRef = doc(db, 'assignments', data.assignmentId);
          const assignmentSnap = await getDoc(assignmentRef);
          const assignmentData = assignmentSnap.exists() ? assignmentSnap.data() : {};
          console.log("📘 Assignment data:", assignmentData);
  
          const timeStarted = data.timeStarted?.toDate?.();
          const timeSubmitted = data.timeSubmitted?.toDate?.();
  
          const durationMins = timeStarted && timeSubmitted
            ? Math.round((timeSubmitted - timeStarted) / 60000)
            : null;
  
            const answered = Array.isArray(data.answers)
  ? data.answers.filter(a => typeof a.correct === 'boolean')
  : [];

// Group answers by questionId
const groupedAnswers = answered.reduce((acc, answer) => {
  if (!acc[answer.questionId]) acc[answer.questionId] = [];
  acc[answer.questionId].push(answer);
  return acc;
}, {});

// Now, for each question, pick the final attempt (last one)
const finalAttempts = Object.values(groupedAnswers).map(attempts => attempts[attempts.length - 1]);

// Now calculate score and total properly
const score = finalAttempts.filter(a => a.correct).length;
const total = finalAttempts.length;
          
  
          const submission = {
            id: docSnap.id,
            assignmentId: data.assignmentId,
            title: assignmentData.title || 'Untitled',
            score,
            total,
            timeStarted,
            timeSubmitted,
            timeTaken: durationMins,
            type: data.type || assignmentData.type || "",  // this is key
            finalAmount: data.finalAmount || null,
          };
          
          console.log("📦 Final submission object:", submission);
          
          return submission;
          
        })
      );
  
      setSubmissions(subs);
      setShowSubmissions(true);
    } catch (err) {
      console.error('Failed to fetch submissions:', err);
    }
  };

  const handleBack = () => {
    function getMillionaireColorClass(amountStr) {
      if (!amountStr) return '';
  
      const num = parseInt(amountStr.replace(/[^\d]/g, '')) || 0;
  
      if (num === 1000000) return 'score-gold';
      if (num >= 32000) return 'score-green';
      if (num >= 1000) return 'score-orange';
      return 'score-red';
    }
  
    setShowSubmissions(false);
    setSelectedStudent(null);
    setSubmissions([]);
  };
  const sortedSubmissions = [...submissions].sort((a, b) => {
    if (!sortField) return 0;
  
    let valA = a[sortField];
    let valB = b[sortField];
  
    // Convert Date objects to timestamps
    if (valA instanceof Date) valA = valA.getTime();
    if (valB instanceof Date) valB = valB.getTime();
  
    // Handle undefined/null
    if (valA == null) return 1;
    if (valB == null) return -1;
  
    if (valA < valB) return sortOrder === 'asc' ? -1 : 1;
    if (valA > valB) return sortOrder === 'asc' ? 1 : -1;
    return 0;
  });
  const handleSort = (field) => {
    if (sortField === field) {
      setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
    } else {
      setSortField(field);
      setSortOrder('asc');
    }
  };
  
  return (
    <TutorLayout>
      <div className="max-w-6xl mx-auto">
        {!showSubmissions ? (
          <>
            <h1 className="text-2xl font-bold mb-4">Student List</h1>

            <div className="student-controls">
  <input
    type="text"
    placeholder="Search students..."
    value={search}
    onChange={(e) => setSearch(e.target.value)}
    className="student-search"
  />
  <button
    onClick={handleReview}
    className="student-review-button"
    disabled={!selectedStudent}
  >
    Review Work
  </button>
</div>


            <div className="overflow-x-auto rounded bg-white shadow border border-gray-300">
              <table className="min-w-full text-sm border-collapse border border-gray-400">
                <thead className="bg-gray-100 text-gray-800 text-left text-sm uppercase tracking-wider">

                  <tr>
                    {[
                      'First Name',
                      'Last Name',
                      'Email',
                      'Subject',
                      'Target Grade',
                      'Last Active',
                    ].map((label, i) => (
                      <th
                        key={i}
                        className="border border-gray-400 px-6 py-4 text-left font-semibold"
                      >
                        {label}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {filteredStudents.map((student, index) => {
                    const isSelected = selectedStudent?.uid === student.uid;
                    const lastActive =
                      student.lastActive?.toDate?.() instanceof Date
                        ? new Date(student.lastActive.toDate()).toLocaleString()
                        : '—';

                    return (
                      <tr
  key={student.uid}
  className={`cursor-pointer transition ${
    isSelected ? 'selected' : 'hover:bg-gray-100'
  }`}
  onClick={() => setSelectedStudent(student)}
  onDoubleClick={() => {
    setSelectedStudent(student); // make sure they're selected first
    handleReview();              // trigger review
  }}
>

                        <td className="border border-gray-400 px-6 py-4">{student.displayName || '-'}</td>
                        <td className="border border-gray-400 px-6 py-4">{student.surname || '-'}</td>
                        <td className="border border-gray-400 px-6 py-4">{student.email}</td>
                        <td className="border border-gray-400 px-6 py-4">{student.subject || '-'}</td>
                        <td className="border border-gray-400 px-6 py-4">{student.targetGrade || '-'}</td>
                        <td className="border border-gray-400 px-6 py-4">{lastActive}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </>
        ) : (
          <div className="mt-10">
           <div className="page-header">
  <div className="back-button-container">
    <button onClick={handleBack} className="back-button">
      ← Back to Student List
    </button>
  </div>

  <div className="student-header">
    <h1 className="student-name">
      {selectedStudent.displayName} {selectedStudent.surname}
    </h1>
    <p className="student-subheading">Assignment Report</p>
  </div>
</div>



            {submissions.length === 0 ? (
              <p className="text-gray-500">No started or completed assignments found.</p>
            ) : (
              <div className="flex justify-center w-full">
  <table className="review-table">
  <thead className="bg-blue-100">
  <tr>
    <th className="px-4 py-2 border cursor-pointer" onClick={() => handleSort('title')}>
      Assignment Title {sortField === 'title' && (sortOrder === 'asc' ? '🔼' : '🔽')}
    </th>
    <th className="px-4 py-2 border cursor-pointer" onClick={() => handleSort('type')}>
      Assignment Type {sortField === 'type' && (sortOrder === 'asc' ? '🔼' : '🔽')}
    </th>
    <th className="px-4 py-2 border cursor-pointer" onClick={() => handleSort('score')}>
      Score {sortField === 'score' && (sortOrder === 'asc' ? '🔼' : '🔽')}
    </th>
    <th className="px-4 py-2 border cursor-pointer" onClick={() => handleSort('timeTaken')}>
      Time Taken {sortField === 'timeTaken' && (sortOrder === 'asc' ? '🔼' : '🔽')}
    </th>
    <th className="px-4 py-2 border cursor-pointer" onClick={() => handleSort('timeStarted')}>
      Started {sortField === 'timeStarted' && (sortOrder === 'asc' ? '🔼' : '🔽')}
    </th>
    <th className="px-4 py-2 border cursor-pointer" onClick={() => handleSort('timeSubmitted')}>
      Submitted {sortField === 'timeSubmitted' && (sortOrder === 'asc' ? '🔼' : '🔽')}
    </th>
    <th className="px-4 py-2 border">Review</th>
  </tr>
</thead>

              
              <tbody>
                
              {sortedSubmissions.map((sub) => {
                  const percentage = sub.total === 0 ? 0 : sub.score / sub.total;
  let scoreClass = "";

  if (percentage === 1) scoreClass = "bg-yellow-300";
  else if (percentage >= 0.7) scoreClass = "bg-green-300";
  else if (percentage >= 0.45) scoreClass = "bg-orange-300";
  else scoreClass = "bg-red-300";
  function getScoreColorClass(score, total) {
    if (!total || total === 0) return '';
  
    const percentage = (score / total) * 100;
  
    if (percentage === 100) return 'score-gold';
    if (percentage >= 70) return 'score-green';
    if (percentage >= 45) return 'score-orange';
    return 'score-red';
  }
  
  return (
    <tr
  key={sub.id}
  className="hover:bg-gray-100"
  onClick={() => {
    console.log("🧐 Submission object:", sub);
  
    let url = "";
  
    if (sub.title && sub.title.toLowerCase().includes("blockbusters")) {
      url = `/blockbusters-review/${sub.assignmentId}?studentUID=${selectedStudent.uid}`;
    } else if (sub.type === "millionaire") {
      url = `/millionaire-review/${sub.assignmentId}/${selectedStudent.uid}`;
    } else if (sub.type === "self-marked-quiz") {
      url = `/self-marked-review/${sub.assignmentId}/${selectedStudent.uid}`;
    }
  
    console.log("🔗 Opening URL:", url);
  
    if (url) {
      window.open(url, '_blank');
    }
  }}
  
  
  style={{ cursor: sub.type === "blockbusters" ? 'pointer' : 'default' }}
>
      <td className="px-4 py-2 border">{sub.title}</td>
      <td className="px-4 py-2 border">
  {sub.type === "self-marked-quiz" && "Self-Marked Quiz"}
  {sub.type === "millionaire" && "Millionaire"}
  {sub.type === "blockbusters" && "Blockbusters"}
  {!["self-marked-quiz", "millionaire", "blockbusters"].includes(sub.type) && "Other"}
</td>
      <td className="px-4 py-2">
  <span className={`score-badge ${sub.type === 'millionaire'
    ? getMillionaireColorClass(sub.finalAmount)
    : getScoreColorClass(sub.score, sub.total)
  }`}>
    {sub.type === 'millionaire'
      ? sub.finalAmount || '—'
      : `${sub.score} / ${sub.total}`}
  </span>
</td>




                    <td className="px-4 py-2 border">
                      {sub.timeTaken ? `${sub.timeTaken} min` : '—'}
                    </td>
                    <td className="px-4 py-2 border">
                      {sub.timeStarted?.toLocaleString() || '—'}
                    </td>
                    <td className="px-4 py-2 border">
                      {sub.timeSubmitted?.toLocaleString() || '—'}
                    </td>
                    <td className="px-4 py-2 border text-center">
                      <button
                        className="review-btn"
                        onClick={() => {
                          let url = '';
                        
                          if (sub.type === 'millionaire') {
                            url = `/millionaire-review/${sub.assignmentId}/${selectedStudent.uid}`;
                          } else if (sub.type === 'blockbusters') {
                            url = `/blockbusters-review/${sub.assignmentId}?studentUID=${selectedStudent.uid}`;
                          } else if (sub.type === 'self-marked-quiz') {
                            url = `/self-marked-review/${sub.assignmentId}/${selectedStudent.uid}`;
                          }
                        
                          if (url) {
                            window.open(url, '_blank');
                          }
                        }}
                        
                        
                      >
                        Review
                      </button>
                    </td>
                  </tr>
                   );
                  })}
              </tbody>
            </table>
            </div>
            )}
          </div>
        )}
      </div>
    </TutorLayout>
  );
}

export default ReviewWorkPage;
